<script>
export let height
</script>

<div class="w-full h-{height} block"></div>